/**
 * Utility functions for generating employee IDs
 */

/**
 * Generates a random employee ID in the format EMP + 6 digits
 * @returns {string} Employee ID in format EMP123456
 */
export function generateEmployeeId() {
  // Generate a random 6-digit number
  const randomNum = Math.floor(100000 + Math.random() * 900000);
  // Format as EMP + 6 digits
  return `EMP${randomNum}`;
}

/**
 * Validates if a string is a valid employee ID format
 * @param {string} employeeId - The employee ID to validate
 * @returns {boolean} True if valid format, false otherwise
 */
export function isValidEmployeeId(employeeId) {
  // Check if it matches the pattern EMP + 6 digits
  const pattern = /^EMP\d{6}$/;
  return pattern.test(employeeId);
}

/**
 * Extracts the numeric part from an employee ID
 * @param {string} employeeId - The employee ID
 * @returns {number|null} The numeric part or null if invalid
 */
export function extractEmployeeNumber(employeeId) {
  if (!isValidEmployeeId(employeeId)) {
    return null;
  }
  return parseInt(employeeId.substring(3), 10);
} 